import React, { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import Switch from "@material-ui/core/Switch";
import PropTypes from "prop-types";
import "./SwitchBox.scss";

export const SwitchBox = ({
    className,
    checked,
    onChange,
    error,
    helperText,
    color,
    label,
    hideHelpText,
    ...restProps
}) => {
    const [ checkedState, setCheckedState ] = useState(false);

    const classes = classNames(
        "switch-box",
        className
    );

    useEffect(()=>{
        setCheckedState(checked);
    },[ checked ]);

    const handleChange = useCallback(()=>{
        if(onChange){
            onChange(!checkedState);
        }
        setCheckedState(!checkedState);
    },[ onChange, checkedState ]);

    return (
        <div className={classes}>
            <label className={"switch-box__box"}>
                <Switch
                    {...restProps}
                    checked={checkedState}
                    onChange={handleChange}
                    color={color}
                />
                {label && <div className={"switch-box__label"}>{label}</div>}
            </label>
            { !hideHelpText && <div className="switch-box__helper-text">{error || helperText}</div>}
        </div>
    );
};

SwitchBox.defaultProps = {
    className: null,
    onChange: () => {},
    checked: false,
    color: "secondary"
};

SwitchBox.propTypes = {
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    hideHelpText: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string
};
